// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3vhmx","noInteraction":"EventWrapper_noInteraction__1FXxG"};